// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateCart as updateCartApi } from "@insite/client-framework/Services/CartService";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, LoadCart, UpdateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";

export const XUpdateCart: typeof UpdateCart = async props => {
    const state = props.getState();
    let { cartId } = state.pages.checkoutShipping;

    // xng-change - get the cartId from the checkoutReviewAndSubmit page because we added a custom select shipTo dropdown
    if (!cartId) {
        cartId = state.pages.checkoutReviewAndSubmit.cartId;
    }
    
    if (cartId && props.apiResult) {
        const cart = getCartState(state, cartId).value!;
        await updateCartApi({
            cart: {
                ...cart,
                shipToId: props.apiResult.id,
            },
        });
    }
};

export const XLoadCart: typeof LoadCart = async props => {
    const state = props.getState();
    let { cartId } = state.pages.checkoutShipping;

    // xng-change - get the cartId from the checkoutReviewAndSubmit page because we added a custom select shipTo dropdown
    if (!cartId) {
        cartId = state.pages.checkoutReviewAndSubmit.cartId;
    }

    if (cartId) {
        props.dispatch(loadCart({ cartId }));
    } else {
        await makeHandlerChainAwaitable(loadCurrentCart)({ getPromotions: true })(props.dispatch, props.getState);
    }
};


replaceInChain(chain, UpdateCart, XUpdateCart);
replaceInChain(chain, LoadCart, XLoadCart);
